import { Button, ButtonGroup, ErrorLoad, MessageWrap, Paginator, StepCSSTransitionGroup, Table, TableBody, Toggle } from "@wg/wows-react-uikit";
import { Tooltip } from "components";
import ApplicationsClanMemberTableItem from "fe2/Components/Requests/ApplicationsClanMemberTableItem";
import InvitesNonClanMemberTableItem from "fe2/Components/Requests/InvitesNonClanMemberTableItem";
import { x } from "helpers/localization";
import { getMemberTooltipContent } from "helpers/tooltip";
import forEach from "lodash/forEach";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import some from "lodash/some";
import PropTypes from "prop-types";
import * as React from "react";
import { Interpolate, translate } from "react-i18next";
import settings from "settings";
import { ClanIsDisbandedTooltip, ClanMembersInfoMissingTooltip, MemberInfoMissingTooltip, MemberIsBannedTooltip, RankTooltipContent } from "tooltips";
import Sticky from "../Sticky/Sticky";
import StickyContainer from "../Sticky/StickyContainer";
import { EntriesTableHead } from "../UIKit";
import styles from "./Entries.scss";

const propTypes = {
  entryType: PropTypes.oneOf(['invites', 'applications']),
  currentAccount: PropTypes.shape({
    id: PropTypes.number.isRequired,
    inClanCooldownTill: PropTypes.string
  }).isRequired,
  clan: PropTypes.shape({
    members_count: PropTypes.number.isRequired
  }),
  entries: PropTypes.shape({
    sort: PropTypes.shape({
      order: PropTypes.string.isRequired,
      isAsc: PropTypes.bool.isRequired
    }).isRequired,
    isFetching: PropTypes.bool.isRequired,
    invites: PropTypes.array,
    applications: PropTypes.array,
    page: PropTypes.number.isRequired,
    meta: PropTypes.object,
    error: PropTypes.object,
    idsToProcess: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired,
  clanRulesContent: PropTypes.object,
  headers: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    isSortable: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    modify: PropTypes.string.isRequired,
    glyph: PropTypes.string
  })).isRequired,
  root: PropTypes.string.isRequired,

  selectedApplicationsPlayersIds: PropTypes.array,
  onApplicationsPlayerTick: PropTypes.func,
  onAllApplicationsPlayersTick: PropTypes.func,
  t: PropTypes.func.isRequired,
  fetchEntriesByCurrentState: PropTypes.func.isRequired,
  onBattleTypeChange: PropTypes.func.isRequired,
  onReloadClick: PropTypes.func.isRequired,

  fetchEntriesByPage: PropTypes.func.isRequired,
  onSortClick: PropTypes.func.isRequired,
  onAcceptedEntry: PropTypes.func.isRequired,
  onDeclinedEntry: PropTypes.func.isRequired,
  onDeclineApplications: PropTypes.func,

  openAccountProfile: PropTypes.func,
  openChatWindow: PropTypes.func,
  onRulesDialogClick: PropTypes.func,

  dropSelection: PropTypes.func
};


class OperationalEntries extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      entryListIds: [],
      fetchByNewPage: false
    };

    this.app = document.getElementById('app');
    this.getMemberTooltipContent = this.getMemberTooltipContent.bind(this);
    this.getRankTooltipContent = this.getRankTooltipContent.bind(this);
    this.onAcceptedEntry = this.onAcceptedEntry.bind(this);
    this.onAllApplicationsPlayersTick = this.onAllApplicationsPlayersTick.bind(this);
    this.onDeclineApplications = this.onDeclineApplications.bind(this);
    // We need this method for invites only, in applications it's not defined
    this.onRulesDialogClick = this.props.onRulesDialogClick && this.props.onRulesDialogClick.bind(this);
  }

  componentDidMount() {

    this.props.fetchEntriesByCurrentState(this.withGlobalSpinner());
    this.app.scrollTop = 0;
  }

  UNSAFE_componentWillUpdate(nextProps) {// eslint-disable-line
    const isScrollAfterLocalFetching = (this.props.entries.isFetching && !nextProps.entries.isFetching && isNull(this.props.entries.error));
    if (isScrollAfterLocalFetching) {
      this.app.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    this.props.dropSelection();
  }


  UNSAFE_componentWillReceiveProps(nextProps) {// eslint-disable-line
    let entryListIds = [];

    forEach(nextProps.entries[nextProps.entryType], value => {
      entryListIds.push(value.id);
    });

    this.setState({
      fetchByNewPage: this.props.entries.page !== nextProps.entries.page,
      entryListIds
    });
  }
  onDeclineApplications() {
    this.props.onDeclineApplications();
  }
  onAllApplicationsPlayersTick() {
    this.props.onAllApplicationsPlayersTick(this.state.entryListIds);
  }

  onAcceptedEntry(entry) {
    Tooltip.manager.destroyActiveTooltip();
    this.props.onAcceptedEntry(entry);
  }

  renderError() {
    const t = this.props.t;
    const message = this.props.entryType === 'invites' ? t('Не удалось получить информацию по приглашениям.') : t('Не удалось получить информацию по заявкам.');

    return <ErrorLoad message={message} onReloadClick={this.props.onReloadClick} t={t} />;
  }

  renderEntries() {
    let entriesList = null;
    const entryType = this.props.entryType;
    const entries = this.props.entries[entryType];
    if (entryType === 'invites') {
      entriesList = entries.map(invite => <InvitesNonClanMemberTableItem key={invite.id} invite={invite} isInProcessCancelation={some(this.props.entries.idsToProcess, id => {return id === invite.id;})} root={this.props.root} currentAccount={this.props.currentAccount} onAcceptedInvite={this.onAcceptedEntry} onDeclinedInvite={this.props.onDeclinedEntry} />);
    } else {
      entriesList = entries.map(application => <ApplicationsClanMemberTableItem key={application.id} isChecked={this.props.selectedApplicationsPlayersIds.indexOf(application.id) !== -1} application={application} clan={this.props.clan} isProcessing={some(this.props.entries.idsToProcess, id => {return id === application.id;})} onAcceptedApplication={this.onAcceptedEntry} onDeclinedApplication={this.props.onDeclinedEntry} openAccountProfile={this.props.openAccountProfile} openChatWindow={this.props.openChatWindow} onApplicationsPlayerTick={this.props.onApplicationsPlayerTick} />);
    }

    return <TableBody>
                {entriesList}
            </TableBody>;
  }

  renderPaginator() {
    if (this.props.entries.meta) {
      return <Paginator page={this.props.entries.page} total={this.props.entries.meta.total} limit={settings.entries.limit} isFetching={this.state.fetchByNewPage} isDisabled={this.props.entries.isFetching} onSelectedPage={this.props.fetchEntriesByPage} />;
    }

    return null;
  }

  renderClanRules() {
    if (this.props.entryType === 'invites') {
      const clanRulesComponent = <Toggle caption={this.props.t('Правилами кланов')} onClick={() => {this.onRulesDialogClick(this.props.clanRulesContent);}} />;
      return <div key="rules" className={styles.rules}>
                    <Interpolate i18nKey={x('Вступая в клан, вы соглашаетесь с %(clanRules)s')} clanRules={clanRulesComponent} />
                </div>;
    }

    return null;
  }

  isGlobalFetching() {
    return this.props.entries.isFetching;
  }

  withGlobalSpinner() {
    return (isNull(this.props.entries.error) && isEmpty(this.props.entries[this.props.entryType]) && isEmpty(this.props.entries.meta));
  }

  getMemberTooltipContent(tooltipTip) {
    if (!tooltipTip) return null;

    const memberId = Number(tooltipTip);
    const members = {};
    this.props.entries[this.props.entryType].forEach(entry => {
      return members[entry.account.id] = entry.account;
    });

    return getMemberTooltipContent(members[memberId], this.props.currentAccount, true);
  }

  getRankTooltipContent(tooltipTip) {
    if (!tooltipTip) return null;

    const memberId = Number(tooltipTip);
    const entries = this.props.entries[this.props.entryType];
    const entry = entries.find(entry => entry.account.id === memberId);

    return <RankTooltipContent rank={entry.statistics.rank} seasonId={entry.statistics.season_id} seasonRank={entry.statistics.season_rank} />;
  }

  renderStickyMenu() {
    if (this.props.entryType === 'invites') return null;

    const {
      t
    } = this.props;

    return <Sticky usedStickyContainerId="operational-entries-table-control-block-sticky-container" isActive={this.props.selectedApplicationsPlayersIds.length > 0} forBottom>
                <div className={styles.isHidden}>
                    {t('Принять выбранные')}
                </div>
                <div className={styles.usersControlBlock}>
                    <ButtonGroup>
                        <Button isHighlighted isDisabled={!this.props.selectedApplicationsPlayersIds.length} onClick={this.onDeclineApplications}>
                            {t('Отклонить выбранные')}
                        </Button>
                    </ButtonGroup>
                </div>
            </Sticky>;
  }

  render() {
    if (this.isGlobalFetching()) return null;

    const {
      t,
      entryType
    } = this.props;
    const total = get(this.props, 'entries.meta.total', 0);
    const isErrored = !isNull(this.props.entries.error);

    const allPlayersIsChecked = this.props.entryType === 'applications' ? this.props.entries[this.props.entryType].length === this.props.selectedApplicationsPlayersIds.length : null;

    if (!isErrored && total === 0 && !this.props.entries.isFetching) {
      let title = t('Нет актуальных заявок');
      let message = t('Заявок на вступление в ваш клан пока нет.');

      if (entryType === 'invites') {
        title = t('Нет актуальных приглашений');
        message = t('У вас пока нет приглашений в клан.');
      }

      return <StepCSSTransitionGroup level={1}>
                    <MessageWrap title={title} message={message} key="operational-message-empty" />
                </StepCSSTransitionGroup>;
    }

    return <StepCSSTransitionGroup level={1}>
                <StickyContainer key="operational-entries-table" id="operational-entries-table-control-block-sticky-container">

                    <Table key="table" isFetching={this.props.entries.isFetching} isErrored={isErrored} stickyContainerId="operational-entries-sticky-container">
                        <EntriesTableHead entryType={this.props.entryType} sort={this.props.entries.sort} headers={this.props.headers} stickyContainerId="operational-entries-sticky-container" onAllApplicationsPlayersTick={this.onAllApplicationsPlayersTick} allPlayersIsChecked={allPlayersIsChecked} onSortClick={this.props.onSortClick} />
                        {isErrored ? this.renderError() : this.renderEntries()}
                    </Table>
                    {this.renderStickyMenu()}
                </StickyContainer>
                {this.renderClanRules()}
                {isErrored ? null : this.renderPaginator()}

                <ClanIsDisbandedTooltip />
                <ClanMembersInfoMissingTooltip />
                <MemberIsBannedTooltip />
                <MemberInfoMissingTooltip />
                <Tooltip id="member-tooltip" getContent={this.getMemberTooltipContent} />
                <Tooltip id="rank-tooltip" getContent={this.getRankTooltipContent} />
            </StepCSSTransitionGroup>;
  }
}

OperationalEntries.propTypes = propTypes;

export default translate()(OperationalEntries);